<svg
  width="12"
  height="22"
  viewBox="0 0 12 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.0015 5.74918L10.0015 16.3292C10.0015 18.4192 8.47146 20.2792 6.39146 20.4792C4.01146 20.7092 2.00146 18.8392 2.00146 16.4992L2.00146 4.13918C2.00146 2.82918 2.94146 1.63918 4.24146 1.50918C5.74146 1.35918 7.00146 2.52918 7.00146 3.99918L7.00146 14.4992C7.00146 15.0492 6.55146 15.4992 6.00146 15.4992C5.45146 15.4992 5.00146 15.0492 5.00146 14.4992L5.00146 5.74918C5.00146 5.33918 4.66146 4.99918 4.25146 4.99918C3.84146 4.99918 3.50146 5.33918 3.50146 5.74918L3.50146 14.3592C3.50146 15.6692 4.44146 16.8592 5.74146 16.9892C7.24146 17.1392 8.50146 15.9692 8.50146 14.4992L8.50146 4.16918C8.50146 2.07918 6.97146 0.219185 4.89146 0.0191839C2.50146 -0.210816 0.501464 1.65918 0.501464 3.99918L0.501465 16.2692C0.501465 19.1392 2.60146 21.7092 5.46146 21.9792C8.75146 22.2792 11.5015 19.7192 11.5015 16.4992L11.5015 5.74918C11.5015 5.33918 11.1615 4.99918 10.7515 4.99918C10.3415 4.99918 10.0015 5.33918 10.0015 5.74918Z"
    fill="black"
    fill-opacity="0.5"
  />
</svg>
